<!--
 * @Author: your name
 * @Date: 2020-10-27 16:31:00
 * @LastEditTime: 2020-11-03 14:32:09
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ShopExpressEdition/src/components/advisory/advisoryDetail/solution.vue
-->
<template>
  <el-row :gutter="20" style="margin-top:20px;">
    <el-col :span="14">
      <solutionPanel :progress="progress" v-on="$listeners"></solutionPanel>
    </el-col>
    <el-col :span="10">
      <solutionTab
        :hand-list="handList"
        :hand-list-simple="handListSimple"
        :say-list="sayList"
        :suit-list="suitList"
        :cannot-list="cannotList"
        :food-list="foodList"
        :food-book="foodBook"
        v-on="$listeners"
      ></solutionTab>
    </el-col>
  </el-row>
</template>
<script>
import solutionPanel from './solutionPanel';
import solutionTab from './solutionTab';

export default {
  components: {
    solutionPanel,
    solutionTab
  },
  props: {
    progress: {},
    handList: {
      type: Object,
      default() {
        return {
          list: [],
          time: ''
        };
      }
    },
    handListSimple: {},
    sayList: {},
    foodList: {},
    suitList: {
      type: Array,
      default: () => []
    },
    cannotList: {
      type: Array,
      default: () => []
    },
    foodBook: {
      type: Array,
      default: () => []
    }
  },
  created() {}
};
</script>
